import { RadioControl } from "wvus-forms";

/**
 * RadioGroup functional component renders a group of radio buttons.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.formMethods - Methods for handling form state.
 * @param {Array} props.items - Array of items to be rendered as radio buttons.
 * @param {string} props.questionName - The name of the question for the radio group.
 *
 * @returns {JSX.Element} The rendered RadioGroup component.
 */
const RadioGroup = ({ formMethods, items, questionName }) => {
  const { getFormState } = formMethods;
  const formFields = getFormState().fields;

  return (
    <div className="display-grid gap-xs">
      {items.map((item) => (
        <RadioControl
          key={item.name}
          fieldId={item.name}
          fieldName={questionName}
          fieldTitle={item.label}
          formMethods={formMethods}
          fieldCheckedDefault={formFields[questionName]?.value === item.name}
        />
      ))}
    </div>
  );
};

export default RadioGroup;
